/**
 * SFX Mute Preference
 *
 * Persists the user's "sfx muted" choice in localStorage so it survives
 * reloads and sessions. Kept INDEPENDENT from any TTS/voice preference —
 * the user might want TTS off but SFX on, or vice versa.
 *
 * SSR-safe: every access is wrapped in try/catch + typeof window checks
 * so this module can be imported during prerender without throwing.
 */

const STORAGE_KEY = 'selna_game_sfx_muted';

function readStored(): boolean {
  try {
    if (typeof window === 'undefined') return false;
    return window.localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    // Private browsing / disabled storage
    return false;
  }
}

function writeStored(muted: boolean): void {
  try {
    if (typeof window === 'undefined') return;
    window.localStorage.setItem(STORAGE_KEY, muted ? '1' : '0');
  } catch {
    /* ignore */
  }
}

/**
 * Read the persisted SFX-muted preference. Defaults to `false` (unmuted).
 */
export function getSfxMuted(): boolean {
  return readStored();
}

/**
 * Persist the SFX-muted preference.
 */
export function setSfxMuted(muted: boolean): void {
  writeStored(muted);
}
